import script from "./SearchText.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchText.vue?vue&type=script&setup=true&lang=ts"

import "./SearchText.vue?vue&type=style&index=0&id=bdc87976&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bdc87976"]])

export default __exports__